/* ECUALAMA: load full-size carousel images as the gallery is used.
 * Load with defer AFTER jQuery and BEFORE theme.min.js.
 * Requires the matching non-featured image markup in media.liquid.
 */
(function ($) {
  'use strict';

  if (!$ || window.eclGalleryLoadingInstalled) return;
  window.eclGalleryLoadingInstalled = true;

  var groupSelector = '[data-product-single-media-group]';
  var imageSelector = 'img[data-ecl-gallery-srcset]';
  var wrapperSelector = '[data-product-single-media-group-wrapper]';

  function setImageSize(image) {
    var width = image.getBoundingClientRect().width;
    if (!width) {
      var group = image.closest(groupSelector);
      width = group && group.getBoundingClientRect().width;
    }
    if (width > 0) image.sizes = Math.ceil(width) + 'px';
  }

  function loadImage(image, selected) {
    if (!image) return;
    if (selected) image.setAttribute('fetchpriority', 'high');
    if (image.hasAttribute('data-ecl-gallery-loaded')) return;

    var srcset = image.getAttribute('data-ecl-gallery-srcset');
    var src = image.getAttribute('data-ecl-gallery-src');
    if (!srcset || !src) return;

    setImageSize(image);
    image.decoding = 'async';
    image.loading = 'eager';
    if (!selected) image.setAttribute('fetchpriority', 'low');
    image.setAttribute('data-ecl-gallery-loaded', 'true');
    image.srcset = srcset;
    image.src = src;
  }

  function loadSlide(slick, index, selected) {
    if (!slick || !slick.$slides || index < 0 || index >= slick.slideCount) return;
    var slide = slick.$slides.get(index);
    if (!slide) return;
    slide.querySelectorAll(imageSelector).forEach(function (image) {
      loadImage(image, selected);
    });
  }

  function getSlick(group) {
    if (!group || !$.fn.slick || !group.classList.contains('slick-initialized')) return null;
    return $(group).slick('getSlick');
  }

  // Delegated events also cover galleries added by the theme editor.
  $(document).on('init.eclGallery reInit.eclGallery', groupSelector, function (event, slick) {
    loadSlide(slick, slick.currentSlide, true);
  });

  // Slick uses this event for arrows, swipes, thumbnail clicks and variant navigation.
  $(document).on('beforeChange.eclGallery', groupSelector, function (event, slick, current, next) {
    loadSlide(slick, next, true);
  });

  // Prepare adjacent images on interaction, not during the initial page load.
  $(document).on('pointerdown.eclGallery touchstart.eclGallery focusin.eclGallery', groupSelector, function () {
    var slick = getSlick(this);
    if (!slick) return;
    loadSlide(slick, slick.currentSlide - 1, false);
    loadSlide(slick, slick.currentSlide + 1, false);
  });

  $(document).on('afterChange.eclGallery', groupSelector, function (event, slick, current) {
    loadSlide(slick, current, true);
    loadSlide(slick, current - 1, false);
    loadSlide(slick, current + 1, false);
  });

  // Start a thumbnail's image before its click reaches Slick.
  $(document).on('pointerover.eclGallery pointerdown.eclGallery touchstart.eclGallery focusin.eclGallery', '[data-product-thumbnail]', function () {
    var wrapper = this.closest(wrapperSelector);
    var mediaId = this.getAttribute('data-media-id');
    if (!wrapper || !mediaId) return;
    wrapper.querySelectorAll(imageSelector).forEach(function (image) {
      if (image.getAttribute('data-media-id') === mediaId) loadImage(image, false);
    });
  });

  // Keep responsive image selection correct after rotating/resizing the screen.
  var resizeTimer;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      document.querySelectorAll(imageSelector + '[data-ecl-gallery-loaded]').forEach(setImageSize);
    }, 150);
  });
})(window.jQuery);
